import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { SECURITY_PROFILE_PATH, VIEW_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import Content from '../../../layout/Content';
import ViewForm from './ViewForm';
import { clearView, getView, putView } from '../../../../actions/security/View';

const EditView = ({
  breadcrumbs,
  view,
  match: {
    params: { id },
  },
  loading,
  dispatchClearView,
  dispatchPutView,
  dispatchGetView
}) => {

  useLayoutEffect(() => {
    dispatchGetView({ id })
    return () => dispatchClearView();
  }, []);

  const onSubmit = (formValues) => {
    dispatchPutView(id, formValues);
  }

  let content;

  if (loading) {
    content = <Loader />;
  } else if (view.isEmpty()) {
    content = <NoDataResource returnPage={SECURITY_PROFILE_PATH} />;
  } else {
    const initialValues = view.toJS();

    content = (
      <ViewForm onSubmit={onSubmit} initialValues={initialValues} />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Vista"
      subtitle="Editar Vista"
      content={content}
    />
  );
}


ViewForm.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetSecurityProfile: PropTypes.func.isRequired,
  dispatchClearSecurityProfile: PropTypes.func.isRequired,
  dispatchPutSecurityProfile: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  securityProfile: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ViewForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (
  { SecurityUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Vistas',
      href: VIEW_PATH,
    },
    {
      text: 'Ver',
      href: `${VIEW_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  view: SecurityUnit.View.getIn(['current', 'content']),
  loading: !SecurityUnit.View.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetView: getView,
  dispatchClearView: clearView,
  dispatchPutView: putView,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditView);
